export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const NEW_PASSWORD_ERROR = "NEW_PASSWORD_ERROR";
